module.exports = __webpack_public_path__ + "img/services-5.ce1ebf14.jpg";